import { Control, Controller, useFormContext } from "react-hook-form";
import { FormValues } from "../CreateCampaign/BuildCampaign";
import KYDInput from "src/ui/KYDInput";
import KYDCheckbox from "src/ui/KYDCheckbox";
import {
  KYDCampaignEvent,
  KYDEventListItemData,
  TextHeadlineData,
} from "@common/interfaces/KYDCampaign";
import {
  useInfiniteHits,
  useInstantSearch,
  useSearchBox,
} from "react-instantsearch";
import { useMemo, useState } from "react";
import { KYDSearchInput } from "src/ui";
import { SearchIcon } from "@chakra-ui/icons";
import { KYDAdminEventSummary } from "@common/interfaces/KYDEvent";
import { HStack, Image, VStack } from "@chakra-ui/react";
import { Text } from "@chakra-ui/react";

const HeadlineBlock = ({
  index,
  control,
  setValue,
  // blk,
  isDisabled,
}: {
  index: number;
  control: Control<FormValues>;
  setValue: (value: any) => void;
  // blk: TextHeadlineData;
  isDisabled?: boolean;
}) => {
  const { watch } = useFormContext<FormValues>();
  const { status: searchStatus } = useInstantSearch();
  const { items: events } = useInfiniteHits<KYDAdminEventSummary>({
    escapeHTML: false,
    showPrevious: false,
  });
  const blk = watch(`blocks.${index}`) as TextHeadlineData;
  const { refine } = useSearchBox();
  const [searchQuery, setSearchQuery] = useState(blk ? blk.event?.name : "");

  const handleSearch = (query: string) => {
    setSearchQuery(query);
    refine(query);
  };

  const handleSelect = (item: KYDAdminEventSummary) => {
    setValue({
      ...blk,
      event: {
        id: item.id,
        name: item.name,
        image: item.image,
        start_at: item.start_at,
        end_at: item.end_at,
        link: item.link,
      } as KYDCampaignEvent,
    } as KYDEventListItemData);

    setSearchQuery(item.name);
  };

  return (
    <>
      <Controller
        name={`blocks.${index}.preheadline` as const}
        control={control}
        render={({ field }) => (
          <KYDInput
            {...field}
            label="Prehead"
            placeholder="Above headline"
            isDisabled={isDisabled}
          />
        )}
      />
      <Controller
        name={`blocks.${index}.headline` as const}
        control={control}
        render={({ field }) => (
          <KYDInput
            {...field}
            label="Headline"
            placeholder="Large heading"
            isDisabled={isDisabled}
          />
        )}
      />
      <Controller
        name={`blocks.${index}.subheadline` as const}
        control={control}
        render={({ field }) => (
          <KYDInput
            {...field}
            label="Subheadline"
            placeholder="Optional"
            isDisabled={isDisabled}
          />
        )}
      />
      <KYDCheckbox
        width="100%"
        id={`link-headline-to-event-${index}`}
        isChecked={blk.link_headline_to_event}
        onChange={(e) => {
          setValue({
            ...blk,
            event: !e.target.checked ? undefined : blk.event,
            link_headline_to_event: e.target.checked,
          });
          setSearchQuery("");
        }}
        label="Link headline to event"
        isDisabled={isDisabled}
      />
      {blk.link_headline_to_event && (
        <KYDSearchInput
          leftIcon={<SearchIcon color="#969696" fontSize="12px" mt={1} />}
          placeholder="Search for events"
          items={events}
          maxHeight="300px"
          width="100%"
          searchField="name"
          value={searchQuery}
          onChange={handleSearch}
          loading={searchStatus === "loading"}
          onSelect={handleSelect}
          isDisabled={isDisabled}
          itemComponent={(item: KYDAdminEventSummary, index: number) => {
            return (
              <HStack
                key={item.id}
                py={2}
                px={3}
                borderBottom={
                  index === events.length - 1 ? "none" : "1px solid #E2E8F0"
                }
                w="100%"
                alignItems="flex-start"
                justifyContent="flex-start"
              >
                <Image
                  borderRadius="8px"
                  width="70px"
                  height="70px"
                  objectFit="cover"
                  src={item.image}
                  alt="Event 2 Column"
                />
                <VStack
                  w="100%"
                  alignItems="flex-start"
                  gap={1}
                  justifyContent="flex-start"
                >
                  <Text fontSize="14px" fontFamily="Helvetica">
                    {item.name}
                  </Text>
                  <Text fontSize="12px" color="#1A202CB2">
                    {item.display_start_at}
                  </Text>
                </VStack>
              </HStack>
            );
          }}
        />
      )}
    </>
  );
};

export default HeadlineBlock;
